// extracted by mini-css-extract-plugin
export default {"MainContainer":"Common_MainContainer__xwO9q","headerDiv":"Common_headerDiv__HPP4K"};